import { NJDocDefTemplate, NJDocData, NJReadDocDefTemplateLookup, DOData } from '../DOData';
import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'cy-template-base',
    template: ''
})

export class CyTemplateComponent
{
    @Input() DocDefTemplate: NJDocDefTemplate;
    @Input() customParameters: any;
    @Input() DocData: NJDocData;
    @Input() loaderKey: string;
    @Input() isValid: boolean;
    @Input() isEnabled: boolean;
    @Input() lstDocDefTemplateLookup: Array<NJReadDocDefTemplateLookup>;
    @Input() LookupId: string;
    @Input() lstChildDocDefTemplate: Array<NJDocDefTemplate>;
    @Input() lstDocData: Array<NJDocData>;
}